// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#kt_content{padding-top:12em}@media screen and (max-width:960px){#kt_content{padding-top:15em}}.v-navigation-drawer{background-image:url(/media/bg/bg-menu.jpg);background-size:256px 100%;background-repeat:no-repeat}", ""]);
// Exports
module.exports = exports;
